import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import './styles.scss'
import Message from '../../ChatMessages/Message'
import { lang } from 'utils/helpers'
import { apiInchat } from 'api'
import { getStaticImage } from 'utils/statics'
import { getFormatedDate } from 'utils'
import { toastMessage } from 'utils/messages'

const Saved = () => {
  const { inchat } = useSelector(store => store)
  const operator = useSelector((state) => state.user)
  const [saved, setSaved] = React.useState([])

  useEffect(() => {
    getMessages()
  }, [])

  const getMessages = async () => {
    apiInchat.savedList()
      .then(({ data }) => {
        setSaved(data || [])
      })
      .catch((err) => {
        toastMessage(lang('inchat_error_get_saved'), 'error')
      })
  }

  const getHeader = (conversation) => {
    if (conversation.type === 'direct') {
      const user = conversation.usersInfo.find(user => user._id !== operator.id)
      const nameToShow = user.name || user.lastname ? `${user.name} ${user.lastname}` : user.email
      return (
        <div className='group-header direct'>
          <span className='title'>{nameToShow}</span>
        </div>
      )
    }
    if (conversation.type === 'group') {
      const participants = conversation.usersInfo.map(user => user.name || user.lastname ? `${user.name} ${user.lastname}` : user.email)
      return (
        <div className='group-header'>
          <span className='title'>{participants.join(' ')}</span>
        </div>
      )
    }
    if (conversation.type === 'channel') {
      const channelName = conversation.name
      return (
        <div className='group-header'>
          <span className='title'>{`#${channelName}`}</span>
        </div>
      )
    }
    return null
  }

  return (
    <div className='inchat-saved'>
      <div className='header'>
        <span className='title-saved'>{lang('inchat_saved')}</span>
      </div>
      <div className='content'>
        { (!inchat.savedMessage || inchat.saved === 0) &&
          <div className='no-saved'>
            <img src={getStaticImage('/icons/orange-brand/icon-empty.svg')} alt='no-saved' />
            <span>{lang('inchat_no_saved')}</span>
          </div>
        }
        {
          saved.map((_saved, index) => {
            return (
              <div key={`id-${index}`} className='group-wrapper'>
                {getHeader(_saved.conversation)}
                <div className='messages'>
                  <Message
                    key={index}
                    message={{
                      ..._saved.message,
                      user: _saved.user,
                    }}
                    showReactions={false}
                    showOptions={false}
                  />
                  <span className='sentat'>{getFormatedDate({ isoString: _saved.message.sentAt, withTime: true, withYear: true })}</span>
                </div>
              </div>
            )}
          )
        }
      </div>
    </div>
  )
}

export default Saved